import { render, staticRenderFns } from "./PortCallBerthAnchorage.vue?vue&type=template&id=737aa6ca&scoped=true&"
import script from "./PortCallBerthAnchorage.vue?vue&type=script&lang=js&"
export * from "./PortCallBerthAnchorage.vue?vue&type=script&lang=js&"
import style0 from "./PortCallBerthAnchorage.vue?vue&type=style&index=0&id=737aa6ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737aa6ca",
  null
  
)

export default component.exports